var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avue-sidebar"},[_c('el-scrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"left-menu"},[_c('img',{staticClass:"item2",staticStyle:{"width":"63px","height":"58px","display":"inline-block"},attrs:{"src":require("@/assets/menu/logo.png")}})]),_vm._v(" "),_c('el-menu',{attrs:{"unique-opened":"","default-active":_vm.nowTagValue,"mode":"vertical","show-timeout":200,"collapse":_vm.keyCollapse}},[_c('sidebar-item',{attrs:{"menu":_vm.menu,"propscreen":_vm.screen,"first":"","nowTagValue":_vm.nowTagValue,"props":{
          label: 'name',
          path: 'path',
          icon: 'source',
          children: 'children'
        },"collapse":_vm.keyCollapse}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-162813d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/index.vue
// module id = null
// module chunks = 